import { Validation } from '@/shared/types/entities/MasterData';
import { State } from '..';
import { MASTER_DATA_MUTATION } from './mutationTypes';

export const masterDataMutations = {
  [MASTER_DATA_MUTATION.SET_GET_PARAMETERS]: (
    state: State,
    validation: Validation,
  ) => {
    state.validation = validation;
  },
};
